module.exports = __webpack_public_path__ + "img/243-8362d2.png";